<div class="featured-news-component-container">

  <ng-template #gotoLink>
    <app-action-link *ngIf="newsCenterUrl" [href]="newsCenterUrl" [target]="'blank'">
      <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
      <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
    </app-action-link>
    <app-action-router-link *ngIf="!newsCenterUrl" [actionRouterLink]="'../pages/news'" [buttonClass]="'align-middle'">
      <span i18n="news see all news link@@news-see-all-news-link">Go to the news center</span>
      <i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
    </app-action-router-link>
  </ng-template>

  <div class="d-none d-md-block float-md-right mt-1"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>
  <h2 i18n="news featured news title@@news-featured-news-title" class="widget-header h4 featured-news-title">Featured news</h2>
  <h3 class="text-muted featured-news-sub-title h6" i18n="news my news sub title@@news-featured-news-sub-title">Read the featured news from {{workplaceName}} today! When you click on a post, it will open in a new tab. You can navigate back here at any time by closing or switching the tab.</h3>
  <div class="d-block d-md-none mt-2 mt-md-0"><ng-container *ngTemplateOutlet="gotoLink"></ng-container></div>

  <div class="featured-news-item-container">
    <div *ngIf="featuredNewsItems$ | async as featuredNewsItems" class="row">
      <div *ngFor="let newsItem of featuredNewsItems" class="col-12 col-md-6 col-lg-4 col-xl-4 col-xxl-3 col-xxl-3 mt-4 overflow-hidden">
        <div class="card front" [ngClass]="newsItem.Picture && !newsItem.Picture.endsWith('sitepagethumbnail.png') ? '' : 'news-item-bg-color'">

          <a href="{{newsItem.Path}}" *ngIf="newsItem.Picture && !newsItem.Picture.endsWith('sitepagethumbnail.png'); else noImage" class="card-img-container featured-news-item-link" i18n-aria-label="news read the news article@@news-read-the-news-article" aria-label="read the news article" title="{{newsItem.Title}}">
            <div class="embed-responsive embed-responsive-16by9">
              <img #newsImageEl [appImgSrcProxy]="newsItem.Picture" *ngIf="newsItem.Picture && newsItem.IsSharePointNews; else lightNewsImage" class="card-img-top embed-responsive-item" alt="{{newsItem.Title}}" [ngStyle]="setFallBackStyle(newsImageEl)" />
              <!-- Because WP Light news have full image urls and don't have to go through appImgSrcProxy -->
              <ng-template #lightNewsImage>
                <img #newsImageEl src="{{newsItem.Picture}}" *ngIf="newsItem.Picture" class="card-img-top embed-responsive-item" alt="{{newsItem.Title}}" [ngStyle]="setFallBackStyle(newsImageEl)" />
              </ng-template>
            </div>
          </a>
          <!--Replacing dummy image with background color-->
          <ng-template #noImage class="card-img-container">
            <div class="embed-responsive embed-responsive-16by9">
              <div class="card-img-top embed-responsive-item"></div>
            </div>
          </ng-template>

          <div class="img-overlay" *ngIf="showNewsDesc">
            <button mat-flat-button aria-label="{{newsItem.Title}}"  color="accent" class="quick-view news-quick-view-btn" (click)="showNewsDescription(newsItem,$event)">
              <span class="small" i18n="news quick view@@news-quick-view"><i class="fa fa-chevron-circle-up" aria-hidden="true"></i> Quick read</span>
            </button>
          </div>

          <div class="card-body">
            <div class="card-subtitle metadata-text">
              <span>{{newsItem.PublishedDate | date}}</span>
              <span *ngIf="(!featureSettings.hideNewsLikes && newsItem.IsSharePointNews) || (featureSettings.hideNewsLikes === 'HideIfNoLikes' && newsItem.LikesCount > 0) || (!newsItem.IsSharePointNews && newsItem.LikesCount > 0)">
                <i aria-label="Number of Likes" i18n-aria-label="@@number-of-likes" role="img" alt="Number of Likes" class="fa fa-heart like-icon mr-2 ml-2"></i>
                <span>{{newsItem.LikesCount}}</span>
              </span>
              <span *ngIf="(!featureSettings.hideNewsComments && newsItem.IsSharePointNews) || (featureSettings.hideNewsComments === 'HideIfNoComments' && newsItem.CommentsCount > 0) || (!newsItem.IsSharePointNews && newsItem.CommentsCount > 0)">
                <i aria-label="Number of Comments" i18n-aria-label="@@number-of-comments" role="img" alt="Number of Comments" class="fa fa-comment comments-icon mr-2 ml-2"></i>
                <span>{{newsItem.CommentsCount}}</span>
              </span>
            </div>

            <a href="{{newsItem.Path}}" class="card-title" title="{{newsItem.Title}}"
               i18n-aria-label="news read the news article@@news-read-the-news-article"
               aria-label="read the news article">
              <span class="badge accent-2-bg-color text-uppercase rounded-0 mr-1" *ngIf="newsItem.ShowNewOrModifiedBadge" i18n="app tile box new@@app-tile-box-new">New</span>
              <h3 class="h55 mb-0 extra-bold">
                {{newsItem.Title}}
              </h3>
            </a>
            <div *ngIf="newsItem.SenderTags">
              <div class="mt-3" [ngClass]="newsItem.Picture && !newsItem.Picture.endsWith('sitepagethumbnail.png') ? 'accent-1-color' : 'card-sendertag'">
                <span>{{getSenderTagString(newsItem)}}</span>
              </div>
          </div>

          </div>

        </div>

        <div class="card back" *ngIf="showNewsDesc && newsItem.hide" @slideInOut>

          <div class="img-overlay" *ngIf="showNewsDesc">
            <button mat-flat-button color="accent" class="quick-view news-quick-view-btn" (click)="showNewsDescription(newsItem,$event)">
              <span class="small" i18n="news quick view@@news-quick-view"><i class="fa fa-chevron-circle-down" aria-hidden="true"></i> Quick read</span>
            </button>
          </div>

          <div class="card-body">
            <div class="card-subtitle metadata-text">
              <span>{{newsItem.PublishedDate | date}}</span>
              <span *ngIf="!featureSettings.hideNewsLikes  || (featureSettings.hideNewsLikes === 'HideIfNoLikes' && newsItem.LikesCount > 0)">
                <i aria-label="Number of Likes" i18n-aria-label="@@number-of-likes" role="img" class="fa fa-heart like-icon mr-2 ml-2"></i>
                <span>{{newsItem.LikesCount}}</span>
              </span>
              <span *ngIf="!featureSettings.hideNewsComments  || (featureSettings.hideNewsComments === 'HideIfNoComments' && newsItem.CommentsCount > 0)">
                <i aria-label="Number of Comments" i18n-aria-label="@@number-of-comments" role="img" class="fa fa-comment comments-icon mr-2 ml-2"></i>
                <span>{{newsItem.CommentsCount}}</span>
              </span>
            </div>

            <a href="{{newsItem.Path}}" class="card-title" title="{{newsItem.Title}}"
               i18n-aria-label="news read the news article@@news-read-the-news-article"
               aria-label="read the news article">
              <span class="badge accent-2-bg-color text-uppercase rounded-0 mr-1" *ngIf="newsItem.ShowNewOrModifiedBadge" i18n="app tile box new@@app-tile-box-new">New</span>
              <h3 class="h55 mb-0 extra-bold">
                {{newsItem.Title}}
              </h3>
            </a>

            <div class="news-description">
              <span class="small">
                {{newsItem.Description}}
              </span>
            </div>
            <span>
              <app-action-link [href]="newsItem.Path" [target]="'blank'" *ngIf="newsItem.IsSharePointNews">
                <span class="small" i18n="open news page in sp@@open-news-page-in-sp">Open this page in sharepoint</span><i class="ml-2 ms-Icon ms-Icon--ArrowUpRight" aria-hidden="true"></i>
              </app-action-link>
            </span>
          </div>

        </div>

      </div>
      <div *ngIf="featuredNewsItems.length === 0">
        <app-text-placeholder>
          <p i18n="featured news none found@@featured-news-none-found">No featured news could be found.</p>
        </app-text-placeholder>
      </div>
    </div>
    <div *ngIf="loading" class="mt-4">
      <div *ngIf="errorSubject$ | async as err; else innerLoading">
        <app-error-templates [error]="err.status" [componentName]="componentName"></app-error-templates>
      </div>
      <ng-template #innerLoading>
        <app-widget-placeholder></app-widget-placeholder>
      </ng-template>
    </div>
  </div>

  <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfNews > amountOfNewsToDisplayCurrently && !loading && numberOfShowMoreClicks < maxNumberOfShowMore else linkToNewsCenter">
    <div class="col-auto">
      <button mat-flat-button color="accent" class="news-show-more-btn" (click)="showMoreNews()"><span i18n="featured news show more@@featured-news-show-more">Show more featured news</span><i class="ml-2 ms-Icon ms-Icon--ChevronDown" aria-hidden="true"></i></button>
    </div>
  </div>
  <div class="row justify-content-center mt-4" *ngIf="fetchedAmountOfNews > amountOfNewsToDisplayCurrently && !loading && numberOfShowMoreClicks === maxNumberOfShowMore">
    <div class="col-auto">
      <button mat-flat-button color="accent" class="news-show-less-btn" (click)="showLessNews()"><span i18n="featured news show less@@featured-news-show-less">Show less featured news</span><i class="ml-2 ms-Icon ms-Icon--ChevronUp" aria-hidden="true"></i></button>
    </div>
  </div>

  <ng-template #linkToNewsCenter>
    <div class="col-auto mt-4 text-center" *ngIf="!loading">
      <span *ngIf="newsCenterUrl" i18n="@@more-news-in-news-center">For older news, open <app-action-link [href]="newsCenterUrl" [target]="'blank'">News Center</app-action-link></span>
      <span *ngIf="!newsCenterUrl" i18n="@@more-news-in-internal-news-center">For older news, open <app-action-router-link [actionRouterLink]="'../pages/news'">News Center</app-action-router-link></span>
    </div>
    <div class="col-auto mt-4 text-center" *ngIf="!loading">

    </div>
  </ng-template>

</div>
